"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOnVtDash = exports.parseHash = void 0;
var routes_1 = require("../constants/routes");
/**
 * helper function.
 * parse a hash string and return an object with name/value key pairs.
 * @param {string} hash
 * @returns {Object}
 */
function parseHash(hash) {
    var valid = function (thisHash) { return thisHash.match(/#(\w.+)/); };
    var stringToArray = function (x) { return x.split('&'); };
    var arrayToObject = function (x) { return x.reduce(function (a, b) {
        var _a;
        var _b = b.split('='), key = _b[0], value = _b[1];
        return __assign(__assign({}, a), (_a = {}, _a[key] = value, _a));
    }, {}); };
    var validHash = valid(hash);
    var hashArray = validHash && stringToArray(validHash[1]);
    return hashArray && arrayToObject(hashArray);
}
exports.parseHash = parseHash;
/**
 * Returns a boolean if the user is currently on a vtdash route
 */
var isOnVtDash = function () { return window.location.pathname.includes(routes_1.BASE_ROUTE_VT_DASH); };
exports.isOnVtDash = isOnVtDash;
